import { firstValueFrom } from 'rxjs';
import type { ConcreteUniverse } from 'src/contracts/universe';
import { getUniverseById as getUniverseByIdObs } from 'src/lib/universes';

export async function getUniverseById(id: string): Promise<ConcreteUniverse | undefined> {
    return firstValueFrom(getUniverseByIdObs(id));
}
